// components/MenuCard.jsx
import React, { useState } from 'react';

const MenuCard = ({ item, onClick }) => {
    const [imageError, setImageError] = useState(false);

    const fallbackImage = 'https://via.placeholder.com/80x80?text=No+Image';
    const imageUrl = item.image && !imageError ? item.image : fallbackImage;

    return (
        <div
            className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 cursor-pointer"
            onClick={() => onClick && onClick(item)}
        >
            <div className="flex p-3 gap-3">
                {/* Image Section */}
                <div className="flex-shrink-0">
                    <img
                        src={imageUrl}
                        alt={item.name}
                        className="w-20 h-20 rounded-lg object-cover"
                        onError={() => setImageError(true)}
                        loading="lazy"
                    />
                </div>

                {/* Content Section */}
                <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-start gap-2">
                        <h3 className="font-bold text-gray-800 text-base truncate">
                            {item.name}
                        </h3>
                        <span className="font-bold text-amber-600 whitespace-nowrap">
                            {typeof item.price === 'number' ? item.price.toFixed(2) : parseFloat(item.price).toFixed(2)} ETB
                        </span>
                    </div>

                    {/* {item.details && (
                        <p className="text-gray-500 text-xs mt-1 line-clamp-2">
                            {item.details}
                        </p>
                    )} */}

                    {/* Optional Add to Cart Button */}
                    <button className="mt-2 text-xs font-medium text-amber-600 hover:text-amber-700 transition-colors flex items-center gap-1 group">
                        <svg className="w-3 h-3 transition-transform group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                        </svg>
                        Add to Order
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MenuCard;